import { Navigate, useLocation } from 'react-router-dom';
import { resolveLegacyPath } from '../../Utils/legacyPaths';

// Old URLs (bookmarks, shared links) of pages that moved in the sidebar regroup redirect to the
// new ones, keeping any trailing path (e.g. a provider id), the query string and the hash.
const LegacyRedirect = () => {
  const { pathname, search, hash } = useLocation();
  const target = resolveLegacyPath(pathname);
  return <Navigate to={target ? `${target}${search}${hash}` : '/'} replace />;
};

export default LegacyRedirect;
